/* global confirm */
import { config } from '@/config'
import cookie from 'cookie_js'

let initGlobalPromise = null

export default {
  state: {

  },
  actions: {
    async initGlobal ({ dispatch }) {
      if (initGlobalPromise) {
        return initGlobalPromise
      }

      let initGlobalPromiseResolve = null
      initGlobalPromise = new Promise((resolve, reject) => {
        initGlobalPromiseResolve = resolve
      })

      await dispatch('cart/getCart')
      await dispatch('account/getLastOrders')
        .catch((err) => {
          console.warn('Tolerated temporary: ', err)
          return Promise.resolve([])
        }) // TODO: this endpoint works only in the mock so far
      await dispatch('storeBasketCookie')

      initGlobalPromiseResolve()
      return initGlobalPromise
    },
    redirectToExistingCart ({ dispatch, getters }) {
      const url = getters['cart/cartShopLink']
      dispatch('redirect', { name: 'toStore', url })
    },
    storeBasketCookie ({ dispatch, getters }) {
      if (getters['cart/hasCart']) {
        cookie.set(config.CART_COOKIE, `${getters['cart/cartStoreId']},${getters['cart/cartStoreName']}`)
      } else {
        cookie.remove(config.CART_COOKIE)
      }

    },
    async redirectToDefaultStore ({ dispatch, getters }, { deliveryType }) {
      const order = getters['account/accountAddress']
      const result = await dispatch('account/orderWithAccount', { order, deliveryType })
        .catch((err) => {
          console.warn('Tolerated temporary: ', err)
          return Promise.resolve({ returnToUrl: '/mockFakedUrl' })
        }) // TODO: this endpoint works only in the mock so far

      // TODO: this could fail, but we have no handling for this
      const url = result.returnToUrl
      dispatch('redirect', { url: url })
    },
    async insertOrderIntoBasketAndRedirect ({ dispatch, getters }, { order, deliveryType }) {
      const result = await dispatch('account/insertOrder', { order, deliveryType })
        .catch((err) => {
          console.warn('Tolerated temporary: ', err)
          return Promise.resolve({ returnToUrl: '/mockFakedUrl' })
        }) // TODO: this endpoint works only in the mock so far

      // TODO: this could fail, but we have no handling for this
      const url = result.returnToUrl
      dispatch('redirect', { url: url })
    },
    redirect ({ dispatch }, { name, url }) {
      if (name === 'toStore') {
        // we have to append the language
        url += `${url.indexOf('&') < 0 ? '?' : '&'}lang=${config.WEBSHOP_ENDPOINT_LANG}`
      }
      // gate if mock
      if (config.MOCK) {
        console.info('would redirect to', url)
        const result = confirm(`Redirect to ${url}`)
        if (!result) {
          return
        }
      }

      window.location.href = url
    }
  },
  getters: {

  },
  mutations: {

  }
}
